import { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, History } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AuditFilters } from "../components/audit/AuditFilters";
import { AuditRow } from "../components/audit/AuditRow";

export default function AuditPage() {
  const { meta } = useOutletContext();
  const { user } = useAuth();
  const [logs, setLogs] = useState(null);
  const [f, setF] = useState({ category: "ALL", action: "ALL", polda: "ALL" });

  const load = useCallback(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v !== "ALL"));
    setLogs(null);
    api.get("/audit", { params }).then((r) => setLogs(r.data)).catch((e) => { toast.error(errMsg(e)); setLogs([]); });
  }, [f]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-6 max-w-[1400px]" data-testid="audit-page">
      <div className="fade-up">
        <div className="eyebrow flex items-center gap-2"><History className="h-3.5 w-3.5" />{user.role === "polda" ? user.polda : "Jejak Audit"}</div>
        <h1 className="mt-2 font-heading font-black tracking-tight text-3xl sm:text-4xl">Riwayat Perubahan</h1>
        <p className="mt-1 text-sm text-muted-foreground">Catatan siapa yang menambah, mengubah, menghapus, atau mengimpor data (300 aktivitas terbaru).</p>
      </div>
      <AuditFilters meta={meta} user={user} f={f} setF={setF} />
      {!logs ? (
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      ) : logs.length === 0 ? (
        <div className="border bg-card grid-bg py-14 text-center text-sm text-muted-foreground" data-testid="audit-empty">
          Belum ada aktivitas yang tercatat untuk filter ini.
        </div>
      ) : (
        <div className="border bg-card divide-y" data-testid="audit-list">
          {logs.map((l) => <AuditRow key={l.log_id} log={l} />)}
        </div>
      )}
    </div>
  );
}
